import { render, staticRenderFns } from "./SelectInventoryLocations.vue?vue&type=template&id=08e71ce2"
import script from "./SelectInventoryLocations.vue?vue&type=script&lang=js"
export * from "./SelectInventoryLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports